/* Rex — Sale of the Week: Living countdown + Minimal entrance (anime.js v4.5). Plays once per load; honors prefers-reduced-motion. */
(function(){
  if (window.__rexSotwAnim) return; window.__rexSotwAnim = true;
  function boot(){
    var A = window.anime; if (!A) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-rxsotw]').forEach(function(sec){
      /* Living countdown — roll a digit only when its value actually changes */
      if (!reduce){
        sec.querySelectorAll('[data-rxdigit]').forEach(function(dg){
          dg.setAttribute('data-last', (dg.textContent || '').trim());
          new MutationObserver(function(){
            var v = (dg.textContent || '').trim();
            if (v === dg.getAttribute('data-last')) return;
            dg.setAttribute('data-last', v);
            A.animate(dg, { translateY: ['-0.5em', 0], opacity: [0.3, 1], duration: 420, ease: 'outExpo' });
          }).observe(dg, { childList: true, characterData: true, subtree: true });
        });
      }
      /* Minimal entrance — fade up once */
      var els = sec.querySelectorAll('[data-rxae]');
      if (!els.length) return;
      if (reduce){ els.forEach(function(el){ el.style.opacity=''; el.style.transform=''; }); return; }
      A.animate(els, { opacity: [0,1], translateY: ['1.4rem', 0], duration: 650, ease: 'outQuad', delay: A.stagger(85) });
    });
  }
  function ready(){ if (window.anime){ boot(); } else { var t=0, iv=setInterval(function(){ if (window.anime || t++ > 150){ clearInterval(iv); boot(); } }, 20); } }
  if (document.readyState !== 'loading'){ ready(); } else { document.addEventListener('DOMContentLoaded', ready); }
})();
